import { render, staticRenderFns } from "./ShiftLock.vue?vue&type=template&id=0815dbaa"
import script from "./ShiftLock.vue?vue&type=script&lang=js"
export * from "./ShiftLock.vue?vue&type=script&lang=js"
import style0 from "./ShiftLock.vue?vue&type=style&index=0&id=0815dbaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports